import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import { NoAssessments } from "../InfoTabs/FlaggedJournals";
import { CBadge } from "@coreui/react";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
    zIndex: 2000,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "75%",
    zIndex: 2001
  },
};

const QuestionTab = ({ sno, text, type, score = "", oneIndexed = false }) => {
  return (
    <div className="d-flex justify-content-between question-tab">
      <div className="question-sno">
        {type}
        {oneIndexed ? sno : sno + 1}
      </div>
      <div className="question-main">
        <label style={{ fontSize: "100%" }}>{text}</label>
        {/* <span className="muted-text">{answer.text}</span> */}
      </div>
      <div className="question-score">{score}</div>
    </div>
  );
};

const ViewAssessmentModal = (props) => {
  Modal.setAppElement("#root");
  const { modalIsOpen, setModalOpen, assessmentName } = props;

  const closeModal = () => {
    setModalOpen(false);
  };

  const { assessmentTypes } = useSelector((state) => state?.assessment);
  const [assessment, setAssessment] = useState(
    assessmentTypes.find((ele) => ele?.name === assessmentName?.label)
  );

  useEffect(() => {
    const targetAssesment = assessmentTypes.find(
      (ele) => ele?.name === assessmentName?.label
    );
    if (targetAssesment) {
      setAssessment(targetAssesment);
    }
  }, [assessmentName]);

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
        ariaHideApp={false}
      >
        <div
          className="container-fluid"
          style={{ margin: "0px", padding: "2.5%" }}
        >
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <CardLayout className="p-3">
            <div className="w-100 py-2 d-flex">
              <h3 className="primary-text-blue">
                {assessmentName?.label || ""}
              </h3>
            </div>
            <div
              className="container-fluid"
              style={{
                margin: "0px",
                padding: "0px",
                overflowY: "scroll",
                height: "50vh",
              }}
            >
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="w-100 py-2 d-flex">
                    <h5 className="primary-text-blue">Questions</h5>
                  </div>
                  {assessment?.questionnaire &&
                    [...assessment.questionnaire]
                      .sort((a, b) => (a?.sort ?? 0) - (b?.sort ?? 0))
                      .map((item) => {
                        return (
                          <QuestionTab
                            text={item?.text}
                            key={item?.id}
                            sno={item?.sort}
                            type="Q"
                          />
                        );
                      })}
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="w-100 py-2 d-flex">
                    <h5 className="primary-text-blue">Answers</h5>
                  </div>
                  {assessment?.answer_group?.answers &&
                    [...assessment.answer_group.answers]
                      .sort((a, b) => (a?.sort ?? 0) - (b?.sort ?? 0))
                      .map((item) => {
                        return (
                          <QuestionTab
                            text={item?.text}
                            key={item?.id}
                            sno={item?.sort}
                            score={item?.score}
                            type="A"
                            oneIndexed={true}
                          />
                        );
                      })}
                </div>

                <div className="cotnainer-fluid px-1 col-sm-12 col-md-12 col-lg-12 my-2 mb-4 px-2 py-1">
                  <div className="w-100 py-2 px-3 d-flex">
                    <h5 className="primary-text-blue">Tags</h5>
                  </div>
                  <div className="d-flex">
                    {assessment?.tag_group?.tags &&
                      assessment?.tag_group?.tags?.map((item, index) => {
                        return (
                          <li className="list-group-item px-3" key={index}>
                            <CBadge color="info" shape="rounded-pill">
                              {item?.label}
                            </CBadge>
                            {"   "}
                            {item?.low_bound}-{item?.high_bound}
                          </li>
                        );
                      })}
                  </div>
                </div>
              </div>

              {assessment === undefined && (
                <NoAssessments
                  text="No Data for this assessment"
                  link_text="Back to Assessments"
                  callback={() => {
                    closeModal();
                  }}
                />
              )}
            </div>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};

export default ViewAssessmentModal;
